// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/2bb1d7b4/" + chunkId + "." + __webpack_require__.h() + ".v2bb1d7b4.js";
};